export class FieldMappingOption {
  id: string;
  name: string;
  mappings: string[];
  required = false;
  readonly isCustomFieldOption: boolean;

  constructor(id: string, name: string, mappings: string[], isCustom = false) {
    this.id = id;
    this.name = name;
    this.mappings = mappings;
    this.isCustomFieldOption = isCustom;
  }
}

export const doNotImportOptionId = 'doNotImport';
// the following FieldMappingOption list is currently sorted alphabetically
// please add new entries alphabetically by the 'name' property, it is not automatically sorted
export const fieldOptions: FieldMappingOption[] = [
  new FieldMappingOption('AdditionalWorkNumber1', 'Additional Work Number 1', ['additionalworknumber1']),
  new FieldMappingOption('AdditionalWorkNumber2', 'Additional Work Number 2', ['additionalworknumber2']),
  new FieldMappingOption('AdditionalWorkNumber3', 'Additional Work Number 3', ['additionalworknumber3']),
  new FieldMappingOption('AdditionalWorkNumber4', 'Additional Work Number 4', ['additionalworknumber4']),
  new FieldMappingOption('AdditionalWorkNumber5', 'Additional Work Number 5', ['additionalworknumber5']),
  new FieldMappingOption('Address', 'Address', [
    'address',
    'street address',
    'organization address',
    'billing street 1',
  ]),
  new FieldMappingOption('Address2', 'Address Line 2', ['address2', 'unit', 'suite']),
  new FieldMappingOption('Brand1', 'Brand 1', ['brand1']),
  new FieldMappingOption('Brand2', 'Brand 2', ['brand2']),
  new FieldMappingOption('Brand3', 'Brand 3', ['brand3']),
  new FieldMappingOption('Brand4', 'Brand 4', ['brand4']),
  new FieldMappingOption('Brand5', 'Brand 5', ['brand5']),
  new FieldMappingOption('Brand6', 'Brand 6', ['brand6']),
  new FieldMappingOption('Brand7', 'Brand 7', ['brand7']),
  new FieldMappingOption('Brand8', 'Brand 8', ['brand8']),
  new FieldMappingOption('Brand9', 'Brand 9', ['brand9']),
  new FieldMappingOption('Brand10', 'Brand 10', ['brand10']),
  new FieldMappingOption('Brand11', 'Brand 11', ['brand11']),
  new FieldMappingOption('Brand12', 'Brand 12', ['brand12']),
  new FieldMappingOption('Brand13', 'Brand 13', ['brand13']),
  new FieldMappingOption('Brand14', 'Brand 14', ['brand14']),
  new FieldMappingOption('Brand15', 'Brand 15', ['brand15']),
  new FieldMappingOption('TaxonomyId', 'Business Category ID', ['taxonomyid', 'organization industry', 'industry']),
  new FieldMappingOption('City', 'City', ['city', 'city/town', 'town', 'billing city']),
  new FieldMappingOption('CompanyName', 'Company Name', [
    'companyname',
    'company name',
    'company',
    'name',
    'organization name',
    'account name',
  ]),
  new FieldMappingOption('CountryCode', 'Country Code', ['countrycode']),
  new FieldMappingOption('CustomerIdentifier', 'Customer Identifier', ['customeridentifier', 'account id']),
  new FieldMappingOption('Description', 'Description', ['description', 'account description']),
  new FieldMappingOption(
    'HealthCareProfessionalInformation_dateOfBirth',
    'Health Care Professional Information Date Of Birth',
    ['healthcareprofessionalinformation_dateofbirth'],
  ),
  new FieldMappingOption('HealthCareProfessionalInformation_email', 'Health Care Professional Information Email', [
    'healthcareprofessionalinformation_email',
  ]),
  new FieldMappingOption(
    'HealthCareProfessionalInformation_fellowship1',
    'Health Care Professional Information Fellowship 1',
    ['healthcareprofessionalinformation_fellowship1'],
  ),
  new FieldMappingOption(
    'HealthCareProfessionalInformation_fellowship2',
    'Health Care Professional Information Fellowship 2',
    ['healthcareprofessionalinformation_fellowship2'],
  ),
  new FieldMappingOption(
    'HealthCareProfessionalInformation_fellowship3',
    'Health Care Professional Information Fellowship 3',
    ['healthcareprofessionalinformation_fellowship3'],
  ),
  new FieldMappingOption(
    'HealthCareProfessionalInformation_firstName',
    'Health Care Professional Information First Name',
    ['healthcareprofessionalinformation_firstname'],
  ),
  new FieldMappingOption('HealthCareProfessionalInformation_gender', 'Health Care Professional Information Gender', [
    'healthcareprofessionalinformation_gender',
  ]),
  new FieldMappingOption(
    'HealthCareProfessionalInformation_initials',
    'Health Care Professional Information Initials',
    ['healthcareprofessionalinformation_initials'],
  ),
  new FieldMappingOption(
    'HealthCareProfessionalInformation_insurancesAccepted1',
    'Health Care Professional Information Insurances Accepted 1',
    ['healthcareprofessionalinformation_insurancesaccepted1'],
  ),
  new FieldMappingOption(
    'HealthCareProfessionalInformation_insurancesAccepted2',
    'Health Care Professional Information Insurances Accepted 2',
    ['healthcareprofessionalinformation_insurancesaccepted2'],
  ),
  new FieldMappingOption(
    'HealthCareProfessionalInformation_insurancesAccepted3',
    'Health Care Professional Information Insurances Accepted 3',
    ['healthcareprofessionalinformation_insurancesaccepted3'],
  ),
  new FieldMappingOption(
    'HealthCareProfessionalInformation_isTakingPatients',
    'Health Care Professional Information Is Taking Patients',
    ['healthcareprofessionalinformation_istakingpatients'],
  ),
  new FieldMappingOption(
    'HealthCareProfessionalInformation_lastName',
    'Health Care Professional Information Last Name',
    ['healthcareprofessionalinformation_lastname'],
  ),
  new FieldMappingOption(
    'HealthCareProfessionalInformation_medicalLicenseNumber',
    'Health Care Professional Information Medical License Number',
    ['healthcareprofessionalinformation_medicallicensenumber'],
  ),
  new FieldMappingOption(
    'HealthCareProfessionalInformation_nationalProviderIdentifier',
    'Health Care Professional Information National Provider Identifier',
    ['healthcareprofessionalinformation_nationalprovideridentifier'],
  ),
  new FieldMappingOption('HealthCareProfessionalInformation_office', 'Health Care Professional Information Office', [
    'healthcareprofessionalinformation_office',
  ]),
  new FieldMappingOption(
    'HealthCareProfessionalInformation_professionalCredential1',
    'Health Care Professional Information Professional Credential 1',
    ['healthcareprofessionalinformation_professionalcredential1'],
  ),
  new FieldMappingOption(
    'HealthCareProfessionalInformation_professionalCredential2',
    'Health Care Professional Information Professional Credential 2',
    ['healthcareprofessionalinformation_professionalcredential2'],
  ),
  new FieldMappingOption(
    'HealthCareProfessionalInformation_professionalCredential3',
    'Health Care Professional Information Professional Credential 3',
    ['healthcareprofessionalinformation_professionalcredential3'],
  ),
  new FieldMappingOption(
    'HealthCareProfessionalInformation_residency1',
    'Health Care Professional Information Residency 1',
    ['healthcareprofessionalinformation_residency1'],
  ),
  new FieldMappingOption(
    'HealthCareProfessionalInformation_residency2',
    'Health Care Professional Information Residency 2',
    ['healthcareprofessionalinformation_residency2'],
  ),
  new FieldMappingOption(
    'HealthCareProfessionalInformation_residency3',
    'Health Care Professional Information Residency 3',
    ['healthcareprofessionalinformation_residency3'],
  ),
  new FieldMappingOption('HealthCareProfessionalInformation_school1', 'Health Care Professional Information School 1', [
    'healthcareprofessionalinformation_school1',
  ]),
  new FieldMappingOption('HealthCareProfessionalInformation_school2', 'Health Care Professional Information School 2', [
    'healthcareprofessionalinformation_school2',
  ]),
  new FieldMappingOption('HealthCareProfessionalInformation_school3', 'Health Care Professional Information School 3', [
    'healthcareprofessionalinformation_school3',
  ]),
  new FieldMappingOption(
    'HealthCareProfessionalInformation_specialty1',
    'Health Care Professional Information Specialty 1',
    ['healthcareprofessionalinformation_specialty1'],
  ),
  new FieldMappingOption(
    'HealthCareProfessionalInformation_specialty2',
    'Health Care Professional Information Specialty 2',
    ['healthcareprofessionalinformation_specialty2'],
  ),
  new FieldMappingOption(
    'HealthCareProfessionalInformation_specialty3',
    'Health Care Professional Information Specialty 3',
    ['healthcareprofessionalinformation_specialty3'],
  ),
  new FieldMappingOption(
    'HealthCareProfessionalInformation_standardizedTitle',
    'Health Care Professional Information Standardized Title',
    ['healthcareprofessionalinformation_standardizedtitle'],
  ),
  new FieldMappingOption(
    'HealthCareProfessionalInformation_stateLicense',
    'Health Care Professional Information State License',
    ['healthcareprofessionalinformation_statelicense'],
  ),
  new FieldMappingOption('HoursClosed1', 'Hours Closed 1', ['hoursclosed1']),
  new FieldMappingOption('HoursClosed2', 'Hours Closed 2', ['hoursclosed2']),
  new FieldMappingOption('HoursClosed3', 'Hours Closed 3', ['hoursclosed3']),
  new FieldMappingOption('HoursClosed4', 'Hours Closed 4', ['hoursclosed4']),
  new FieldMappingOption('HoursClosed5', 'Hours Closed 5', ['hoursclosed5']),
  new FieldMappingOption('HoursClosed6', 'Hours Closed 6', ['hoursclosed6']),
  new FieldMappingOption('HoursClosed7', 'Hours Closed 7', ['hoursclosed7']),
  new FieldMappingOption('HoursDays1', 'Hours Days 1', ['hoursdays1']),
  new FieldMappingOption('HoursDays2', 'Hours Days 2', ['hoursdays2']),
  new FieldMappingOption('HoursDays3', 'Hours Days 3', ['hoursdays3']),
  new FieldMappingOption('HoursDays4', 'Hours Days 4', ['hoursdays4']),
  new FieldMappingOption('HoursDays5', 'Hours Days 5', ['hoursdays5']),
  new FieldMappingOption('HoursDays6', 'Hours Days 6', ['hoursdays6']),
  new FieldMappingOption('HoursDays7', 'Hours Days 7', ['hoursdays7']),
  new FieldMappingOption('HoursNotes1', 'Hours Notes 1', ['hoursnotes1']),
  new FieldMappingOption('HoursNotes2', 'Hours Notes 2', ['hoursnotes2']),
  new FieldMappingOption('HoursNotes3', 'Hours Notes 3', ['hoursnotes3']),
  new FieldMappingOption('HoursNotes4', 'Hours Notes 4', ['hoursnotes4']),
  new FieldMappingOption('HoursNotes5', 'Hours Notes 5', ['hoursnotes5']),
  new FieldMappingOption('HoursNotes6', 'Hours Notes 6', ['hoursnotes6']),
  new FieldMappingOption('HoursNotes7', 'Hours Notes 7', ['hoursnotes7']),
  new FieldMappingOption('HoursOpen1', 'Hours Open 1', ['hoursopen1']),
  new FieldMappingOption('HoursOpen2', 'Hours Open 2', ['hoursopen2']),
  new FieldMappingOption('HoursOpen3', 'Hours Open 3', ['hoursopen3']),
  new FieldMappingOption('HoursOpen4', 'Hours Open 4', ['hoursopen4']),
  new FieldMappingOption('HoursOpen5', 'Hours Open 5', ['hoursopen5']),
  new FieldMappingOption('HoursOpen6', 'Hours Open 6', ['hoursopen6']),
  new FieldMappingOption('HoursOpen7', 'Hours Open 7', ['hoursopen7']),
  new FieldMappingOption('HoursPublicHolidays1', 'Hours Public Holidays 1', ['hourspublicholidays1']),
  new FieldMappingOption('HoursPublicHolidays2', 'Hours Public Holidays 2', ['hourspublicholidays2']),
  new FieldMappingOption('HoursPublicHolidays3', 'Hours Public Holidays 3', ['hourspublicholidays3']),
  new FieldMappingOption('HoursPublicHolidays4', 'Hours Public Holidays 4', ['hourspublicholidays4']),
  new FieldMappingOption('HoursPublicHolidays5', 'Hours Public Holidays 5', ['hourspublicholidays5']),
  new FieldMappingOption('HoursPublicHolidays6', 'Hours Public Holidays 6', ['hourspublicholidays6']),
  new FieldMappingOption('HoursPublicHolidays7', 'Hours Public Holidays 7', ['hourspublicholidays7']),
  new FieldMappingOption('Landmark', 'Landmark', ['landmark']),
  new FieldMappingOption('Logo', 'Logo', ['logo']),
  new FieldMappingOption('PaymentAmericanExpress', 'Payment American Express', ['paymentamericanexpress']),
  new FieldMappingOption('PaymentAndroidPay', 'Payment Android Pay', ['paymentandroidpay']),
  new FieldMappingOption('PaymentApplePay', 'Payment Apple Pay', ['paymentapplepay']),
  new FieldMappingOption('PaymentCash', 'Payment Cash', ['paymentcash']),
  new FieldMappingOption('PaymentCheck', 'Payment Check', ['paymentcheck']),
  new FieldMappingOption('PaymentDebit', 'Payment Debt', ['paymentdebit']),
  new FieldMappingOption('PaymentDinersClub', 'Payment Diners Club', ['paymentdinersclub']),
  new FieldMappingOption('PaymentDiscover', 'Payment Discover', ['paymentdiscover']),
  new FieldMappingOption('PaymentMasterCard', 'Payment Mastercard', ['paymentmastercard']),
  new FieldMappingOption('PaymentPayPal', 'Payment PayPal', ['paymentpaypal']),
  new FieldMappingOption('PaymentSamsungPay', 'Payment Samsung Pay', ['paymentsamsungpay']),
  new FieldMappingOption('PaymentStoreCard', 'Payment Store Card', ['paymentstorecard']),
  new FieldMappingOption('PaymentTravelersChecks', 'Payment Travelers Checks', ['paymenttravelerschecks']),
  new FieldMappingOption('PaymentVisa', 'Payment Visa', ['paymentvisa']),
  new FieldMappingOption('PrimaryPhoto', 'Primary Photo', ['primaryphoto']),
  new FieldMappingOption('SalesPersonEmail', 'Sales Person Email', ['salespersonemail']),
  new FieldMappingOption('Service1', 'Service 1', ['service1']),
  new FieldMappingOption('Service2', 'Service 2', ['service2']),
  new FieldMappingOption('Service3', 'Service 3', ['service3']),
  new FieldMappingOption('Service4', 'Service 4', ['service4']),
  new FieldMappingOption('Service5', 'Service 5', ['service5']),
  new FieldMappingOption('Service6', 'Service 6', ['service6']),
  new FieldMappingOption('Service7', 'Service 7', ['service7']),
  new FieldMappingOption('Service8', 'Service 8', ['service8']),
  new FieldMappingOption('Service9', 'Service 9', ['service9']),
  new FieldMappingOption('Service10', 'Service 10', ['service10']),
  new FieldMappingOption('Service11', 'Service 11', ['service11']),
  new FieldMappingOption('Service12', 'Service 12', ['service12']),
  new FieldMappingOption('Service13', 'Service 13', ['service13']),
  new FieldMappingOption('Service14', 'Service 14', ['service14']),
  new FieldMappingOption('Service15', 'Service 15', ['service15']),
  new FieldMappingOption('ServiceAreaBusiness', 'Service Area Business', ['serviceareabusiness']),
  new FieldMappingOption('ShortDescription', 'Short Description', ['shortdescription']),
  new FieldMappingOption('State', 'State/Province', ['state', 'province', 'state/province', 'prov', 'billing state']),
  new FieldMappingOption('Tag1', 'Tag 1', ['tag1']),
  new FieldMappingOption('Tag2', 'Tag 2', ['tag2']),
  new FieldMappingOption('Tag3', 'Tag 3', ['tag3']),
  new FieldMappingOption('Tag4', 'Tag 4', ['tag4']),
  new FieldMappingOption('Tag5', 'Tag 5', ['tag5']),
  new FieldMappingOption('Tag6', 'Tag 6', ['tag6']),
  new FieldMappingOption('Tag7', 'Tag 7', ['tag7']),
  new FieldMappingOption('Tag8', 'Tag 8', ['tag8']),
  new FieldMappingOption('Tag9', 'Tag 9', ['tag9']),
  new FieldMappingOption('Tag10', 'Tag 10', ['tag10']),
  new FieldMappingOption('Tag11', 'Tag 11', ['tag11']),
  new FieldMappingOption('Tag12', 'Tag 12', ['tag12']),
  new FieldMappingOption('Tag13', 'Tag 13', ['tag13']),
  new FieldMappingOption('Tag14', 'Tag 14', ['tag14']),
  new FieldMappingOption('Tag15', 'Tag 15', ['tag15']),
  new FieldMappingOption('TollFreeNumber', 'Toll Free Number', ['tollfreenumber']),
  new FieldMappingOption('UserEmail1', 'User Email 1', [
    'useremail1',
    'useremail',
    'company owner',
    'person - email',
    'e-mail',
  ]),
  new FieldMappingOption('UserEmail2', 'User Email 2', ['useremail2']),
  new FieldMappingOption('UserEmail3', 'User Email 3', ['useremail3']),
  new FieldMappingOption('UserEmail4', 'User Email 4', ['useremail4']),
  new FieldMappingOption('UserEmail5', 'User Email 5', ['useremail5']),
  new FieldMappingOption('UserEmail6', 'User Email 6', ['useremail6']),
  new FieldMappingOption('UserEmail7', 'User Email 7', ['useremail7']),
  new FieldMappingOption('UserEmail8', 'User Email 8', ['useremail8']),
  new FieldMappingOption('UserEmail9', 'User Email 9', ['useremail9']),
  new FieldMappingOption('UserEmail10', 'User Email 10', ['useremail10']),
  new FieldMappingOption('UserGreetingName1', 'User Greeting Name 1', [
    'usergreetingname1',
    'usergreetingname',
    'Person - Greeting Name',
  ]),
  new FieldMappingOption('UserGreetingName2', 'User Greeting Name 2', ['usergreetingname2']),
  new FieldMappingOption('UserGreetingName3', 'User Greeting Name 3', ['usergreetingname3']),
  new FieldMappingOption('UserGreetingName4', 'User Greeting Name 4', ['usergreetingname4']),
  new FieldMappingOption('UserGreetingName5', 'User Greeting Name 5', ['usergreetingname5']),
  new FieldMappingOption('UserGreetingName6', 'User Greeting Name 6', ['usergreetingname6']),
  new FieldMappingOption('UserGreetingName7', 'User Greeting Name 7', ['usergreetingname7']),
  new FieldMappingOption('UserGreetingName8', 'User Greeting Name 8', ['usergreetingname8']),
  new FieldMappingOption('UserGreetingName9', 'User Greeting Name 9', ['usergreetingname9']),
  new FieldMappingOption('UserGreetingName10', 'User Greeting Name 10', ['usergreetingname10']),
  new FieldMappingOption('UserFirstName1', 'User First Name 1', [
    'userfirstname1',
    'userfirstname',
    'Person - First Name',
  ]),
  new FieldMappingOption('UserFirstName2', 'User First Name 2', ['userfirstname2']),
  new FieldMappingOption('UserFirstName3', 'User First Name 3', ['userfirstname3']),
  new FieldMappingOption('UserFirstName4', 'User First Name 4', ['userfirstname4']),
  new FieldMappingOption('UserFirstName5', 'User First Name 5', ['userfirstname5']),
  new FieldMappingOption('UserFirstName6', 'User First Name 6', ['userfirstname6']),
  new FieldMappingOption('UserFirstName7', 'User First Name 7', ['userfirstname7']),
  new FieldMappingOption('UserFirstName8', 'User First Name 8', ['userfirstname8']),
  new FieldMappingOption('UserFirstName9', 'User First Name 9', ['userfirstname9']),
  new FieldMappingOption('UserFirstName10', 'User First Name 10', ['userfirstname10']),
  new FieldMappingOption('UserLanguageCode1', 'User Language Code 1', [
    'userlanguagecode1',
    'userlanguagecode',
    'Person - Language Code',
  ]),
  new FieldMappingOption('UserLanguageCode2', 'User Language Code 2', ['userlanguagecode2']),
  new FieldMappingOption('UserLanguageCode3', 'User Language Code 3', ['userlanguagecode3']),
  new FieldMappingOption('UserLanguageCode4', 'User Language Code 4', ['userlanguagecode4']),
  new FieldMappingOption('UserLanguageCode5', 'User Language Code 5', ['userlanguagecode5']),
  new FieldMappingOption('UserLanguageCode6', 'User Language Code 6', ['userlanguagecode6']),
  new FieldMappingOption('UserLanguageCode7', 'User Language Code 7', ['userlanguagecode7']),
  new FieldMappingOption('UserLanguageCode8', 'User Language Code 8', ['userlanguagecode8']),
  new FieldMappingOption('UserLanguageCode9', 'User Language Code 9', ['userlanguagecode9']),
  new FieldMappingOption('UserLanguageCode10', 'User Language Code 10', ['userlanguagecode10']),
  new FieldMappingOption('UserLastName1', 'User Last Name 1', ['userlastname1', 'userlastname', 'Person - Last Name']),
  new FieldMappingOption('UserLastName2', 'User Last Name 2', ['userlastname2']),
  new FieldMappingOption('UserLastName3', 'User Last Name 3', ['userlastname3']),
  new FieldMappingOption('UserLastName4', 'User Last Name 4', ['userlastname4']),
  new FieldMappingOption('UserLastName5', 'User Last Name 5', ['userlastname5']),
  new FieldMappingOption('UserLastName6', 'User Last Name 6', ['userlastname6']),
  new FieldMappingOption('UserLastName7', 'User Last Name 7', ['userlastname7']),
  new FieldMappingOption('UserLastName8', 'User Last Name 8', ['userlastname8']),
  new FieldMappingOption('UserLastName9', 'User Last Name 9', ['userlastname9']),
  new FieldMappingOption('UserLastName10', 'User Last Name 10', ['userlastname10']),
  new FieldMappingOption('UserPhoneNumber1', 'User Phone Number 1', ['userphonenumber1']),
  new FieldMappingOption('UserPhoneNumber2', 'User Phone Number 2', ['userphonenumber2']),
  new FieldMappingOption('UserPhoneNumber3', 'User Phone Number 3', ['userphonenumber3']),
  new FieldMappingOption('UserPhoneNumber4', 'User Phone Number 4', ['userphonenumber4']),
  new FieldMappingOption('UserPhoneNumber5', 'User Phone Number 5', ['userphonenumber5']),
  new FieldMappingOption('UserPhoneNumber6', 'User Phone Number 6', ['userphonenumber6']),
  new FieldMappingOption('UserPhoneNumber7', 'User Phone Number 7', ['userphonenumber7']),
  new FieldMappingOption('UserPhoneNumber8', 'User Phone Number 8', ['userphonenumber8']),
  new FieldMappingOption('UserPhoneNumber9', 'User Phone Number 9', ['userphonenumber9']),
  new FieldMappingOption('UserPhoneNumber10', 'User Phone Number 10', ['userphonenumber10']),
  new FieldMappingOption('Website', 'Website', ['website', 'company domain']),
  new FieldMappingOption('WorkNumber', 'Work Number', ['worknumber', 'phone number', 'account phone']),
  new FieldMappingOption('Zip', 'Zip', [
    'zipcode',
    'zip code',
    'zip',
    'postal code',
    'postalcode',
    'billing postal code',
  ]),
];
fieldOptions.push(new FieldMappingOption(doNotImportOptionId, 'Do Not Import', [doNotImportOptionId.toLowerCase()]));
